export default __webpack_public_path__ + "static/FBH-Final-Logo-e7e5468575dfb53bc933d47241baddc1.png";